var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-check"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtract"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.99935 4.66634V1.48046C5.87741 1.54312 5.76476 1.62478 5.66602 1.72353L3.05654 4.33301C2.95779 4.43176 2.87613 4.5444 2.81346 4.66634H5.99935Z",
    fill: "#03543F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33268 4.66634V1.33301H11.9993C12.7357 1.33301 13.3327 1.92996 13.3327 2.66634V13.333C13.3327 14.0694 12.7357 14.6663 11.9993 14.6663H3.99935C3.26297 14.6663 2.66602 14.0694 2.66602 13.333V5.99967H5.99935C6.73573 5.99967 7.33268 5.40272 7.33268 4.66634ZM10.4708 8.47108C10.7311 8.21073 10.7311 7.78862 10.4708 7.52827C10.2104 7.26792 9.78829 7.26792 9.52794 7.52827L7.33268 9.72353L6.47075 8.8616C6.2104 8.60125 5.78829 8.60125 5.52794 8.8616C5.26759 9.12195 5.26759 9.54406 5.52794 9.80441L6.86128 11.1377C7.12163 11.3981 7.54374 11.3981 7.80409 11.1377L10.4708 8.47108Z",
    fill: "#03543F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file-check.9aa9d84c9bdd2e8604512572999b9887.svg";
export { ForwardRef as ReactComponent };